import React from 'react';
import Organization from '../../components/spravochniki/organization/Organization';

function OrganizationPage(props) {
    return (
        <>
          <Organization />  
        </>
    );
}

export default OrganizationPage;